// EUR formatting using Dutch locale → "€ 16,00"
const _fmt = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
});

export function fmtEUR(value) {
  const n = Number(value);
  if (!isFinite(n)) return "—";
  return _fmt.format(n);
}
